"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBack = void 0;
var react_1 = __importDefault(require("react"));
var IconBack = function (_a) {
    var className = _a.className, height = _a.height, width = _a.width;
    return (react_1.default.createElement("svg", { className: className, height: height, viewBox: '0 0 24 24', width: width },
        react_1.default.createElement("g", { transform: 'rotate(-180 12 12)' },
            react_1.default.createElement("path", { d: 'M19.494,11.4991 L5.644,11.4991 L11.859,4.8401 C12.048,4.6391 12.037,4.3221 11.835,4.1341 C11.635,3.9451 11.317,3.9581 11.129,4.1581 L4.129,11.6581 C4.12,11.6671 4.121,11.6811 4.113,11.6901 C4.066,11.7481 4.035,11.8111 4.017,11.8821 C4.013,11.9011 4.007,11.9191 4.005,11.9391 C3.994,12.0221 4.002,12.1061 4.033,12.1861 C4.035,12.1891 4.033,12.1941 4.035,12.1981 C4.04,12.2101 4.053,12.2151 4.058,12.2271 C4.079,12.2661 4.098,12.3061 4.129,12.3401 L11.129,19.8401 C11.227,19.9451 11.36,19.9991 11.494,19.9991 C11.616,19.9991 11.739,19.9541 11.835,19.8641 C12.037,19.6761 12.048,19.3591 11.859,19.1581 L5.644,12.4991 L19.494,12.4991 C19.77,12.4991 19.994,12.2751 19.994,11.9991 C19.994,11.7231 19.77,11.4991 19.494,11.4991', fill: '#464650', fillRule: 'evenodd' }))));
};
exports.IconBack = IconBack;
exports.IconBack.defaultProps = {
    height: '1em',
    width: '1em'
};
exports.default = exports.IconBack;
